import styles from './Success.module.css';
import { useSuccess } from './Success.hooks';

import { Loading } from '@/components/loading/Loading';
import { Link } from '@tanstack/react-router';

export const Success = () => {
	const { isLoading, error, isSubscribed } = useSuccess();
	if (error) {
		return <div className={styles['error']}>{error.message}</div>;
	}
	if (isLoading) {
		return (
			<div className={styles['loading']}>
				<Loading />
			</div>
		);
	}

	if (!isSubscribed) {
		return <SubscriptionRequired />;
	}

	return <SuccessAuthenticated />;
};

function SubscriptionRequired() {
	return (
		<div className={styles['subscription-required']}>
			<section>
				<h1>Login Successful</h1>
				<h2>A subscription is required to access this content.</h2>

				<Link to={'/subscriptions'}>Buy Subscription</Link>
				<p>
					Or <Link to={'/'}>Return to Magazine</Link>
				</p>
			</section>
		</div>
	);
}

function SuccessAuthenticated() {
	return (
		<div className={styles['subscription']}>
			<section>
				<h1>Payment Successful</h1>
				<h2>Thanks for purchasing a subscription</h2>
				<Link to={'/'}>Return to Magazine</Link>
			</section>
		</div>
	);
}
